import { AllessehQuerySortKeyTypes, AllessehQuerySortOrderType } from 'hooks/useAllessehContentQuery';
import {
  COMMON_QUERY_RULES_CONFIG,
  COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
  DEFAULT_PRODUCT_VALUE,
  DEFAULT_SORT_CONFIG
} from './shared/configs';

enum SECTION_ENUM {
  ARTS_CULTURE = 'Arts & Culture',
  BOOKS = 'Books',
  FILM = 'Film',
  FINE_ART = 'Fine Art',
  FOOD_COOKING = 'Food & Cooking',
  HISTORY = 'History',
  WHAT_WATCH = 'What to Watch',
  MUSIC = 'Music',
  TELEVISION = 'Television',
  THEATER = 'Theater',
  RELATED_OPINION = 'Related Opinion',
  RECENT_REVIEWS = 'Recent Reviews',
  REVIEWS_ROUNDUP = 'Reviews Roundup',
  APPRECIATION = 'Appreciation',
  ARCHITECTURE_REVIEW = 'Architecture Review',
  DANCE_REVIEW = 'Dance Review',
  OPERA_REVIEW = 'Opera Review',
  EXHIBITION_REVIEW = 'Exhibition Review',
  CULTURAL_COMMENTARY = 'Cultural Commentary',
  VIDEO = 'Video'
}

const createSupportingModule = (key: string, value: string[]) => ({
  query: {
    and: [{ term: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } }, { terms: { key, value } }],
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? [])]
  },
  count: 5,
  sort: [{ key: AllessehQuerySortKeyTypes.LiveDate, order: AllessehQuerySortOrderType.DESC }]
});

const ARTS = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    and: [...(COMMON_QUERY_RULES_CONFIG.and ?? []), { term: { key: 'SectionType', value: 'cultural conversation' } }],
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? [])],
    or: [
      { terms: { key: 'DJEThing', value: ['arts-culture'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['arts-culture/books'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['arts-culture/film'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['arts-culture/television'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['arts-culture/food-cooking'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['arts-culture/music'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['arts-culture/fine-art'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['arts-culture/theater'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['arts-culture/history'] } },
      { terms: { key: 'SectionType', value: ['cultural commentary'] } }
    ]
  }
};

const MORE = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [
      { terms: { key: 'DJEThing', value: ['arts-culture'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['arts-culture/books'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['arts-culture/film'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['arts-culture/television'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['arts-culture/food-cooking'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['arts-culture/music'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['arts-culture/fine-art'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['arts-culture/theater'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['arts-culture/history'] } },
      { terms: { key: 'SectionType', value: ['cultural commentary'] } }
    ]
  }
};

const BOOKS = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    and: [...(COMMON_QUERY_RULES_CONFIG.and ?? [])],
    or: [
      { terms: { key: 'DJEThing', value: ['arts-culture/books'] } },
      { terms: { key: 'SectionType', value: ['cultural commentary'] } }
    ],
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? [])]
  }
};

const FILM = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    and: [...(COMMON_QUERY_RULES_CONFIG.and ?? [])],
    or: [
      { terms: { key: 'DJEThing', value: ['arts-culture/film'] } },
      { terms: { key: 'SectionType', value: ['cultural commentary'] } }
    ],
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? [])]
  }
};

const FINE_ART = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    and: [...(COMMON_QUERY_RULES_CONFIG.and ?? [])],
    or: [
      { terms: { key: 'DJEThing', value: ['arts-culture/fine-art'] } },
      { terms: { key: 'SectionType', value: ['cultural commentary'] } }
    ],
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? [])]
  }
};

const FOOD_COOKING = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    and: [...(COMMON_QUERY_RULES_CONFIG.and ?? [])],
    or: [
      { terms: { key: 'DJEThing', value: ['arts-culture/food-cooking'] } },
      { terms: { key: 'SectionType', value: ['cultural commentary'] } }
    ],
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? [])]
  }
};

const HISTORY = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    and: [...(COMMON_QUERY_RULES_CONFIG.and ?? [])],
    or: [
      { terms: { key: 'DJEThing', value: ['arts-culture/history'] } },
      { terms: { key: 'SectionType', value: ['cultural commentary'] } }
    ],
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? [])]
  }
};

const MUSIC = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    and: [...(COMMON_QUERY_RULES_CONFIG.and ?? [])],
    or: [
      { terms: { key: 'DJEThing', value: ['arts-culture/music'] } },
      { terms: { key: 'SectionType', value: ['cultural commentary'] } }
    ],
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? [])]
  }
};

const TELEVISION = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    and: [...(COMMON_QUERY_RULES_CONFIG.and ?? [])],
    or: [
      { terms: { key: 'DJEThing', value: ['arts-culture/television'] } },
      { terms: { key: 'SectionType', value: ['cultural commentary'] } }
    ],
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? [])]
  }
};

const THEATER = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    and: [...(COMMON_QUERY_RULES_CONFIG.and ?? [])],
    or: [
      { terms: { key: 'DJEThing', value: ['arts-culture/theater'] } },
      { terms: { key: 'SectionType', value: ['cultural commentary'] } }
    ],
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? [])]
  }
};

const RELATED_OPINION = {
  ...DEFAULT_SORT_CONFIG,
  query: COMMON_RELATED_OPINION_QUERY_RULES_CONFIG
};

const RECENT_REVIEWS = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    and: [
      ...(COMMON_QUERY_RULES_CONFIG.and ?? []),
      { term: { key: 'ContentType', value: 'article' } },
      { term: { key: 'SectionType', value: 'cultural conversation' } }
    ],
    or: [
      { term: { key: 'SectionName', value: 'Arts' } },
      { terms: { key: 'SectionType', value: ['cultural commentary'] } }
    ],
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? [])]
  }
};

const REVIEWS_ROUNDUP = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    and: [...(COMMON_QUERY_RULES_CONFIG.and ?? []), { term: { key: 'ContentType', value: 'article' } }],
    or: [
      { term: { key: 'SectionName', value: 'Arts' } },
      { terms: { key: 'SectionType', value: ['cultural commentary'] } }
    ],
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? [])]
  }
};

const WHAT_WATCH = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    and: [...(COMMON_QUERY_RULES_CONFIG.and ?? []), { term: { key: 'ContentType', value: 'article' } }],
    or: [
      { term: { key: 'ColumnName', value: 'What to Watch' } },
      { terms: { key: 'SectionType', value: ['cultural commentary'] } }
    ],
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? [])]
  }
};

const APPRECIATION = createSupportingModule('ColumnName', ['Appreciation']);

const ARCHITECTURE_REVIEW = createSupportingModule('ColumnName', ['Architecture Review']);

const DANCE_REVIEW = createSupportingModule('ColumnName', ['Dance Review']);

const OPERA_REVIEW = createSupportingModule('ColumnName', ['Opera Review']);

const EXHIBITION_REVIEW = createSupportingModule('ColumnName', ['Exhibition Review']);

const CULTURAL_COMMENTARY = createSupportingModule('ColumnName', ['Cultural Commentary']);

const VIDEO = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    and: [
      { term: { key: 'ContentType', value: 'video' } },
      { terms: { key: 'Product', value: ['wsj video', 'wsj opinion video podcast'] } },
      { term: { key: 'LanguageCode', value: 'en' } }
    ],
    or: [{ term: { key: 'DJEThing', value: 'arts-culture' } }, { prefix: { key: 'DJEThing', value: 'arts-culture/' } }]
  }
};

export {
  SECTION_ENUM,
  ARTS,
  BOOKS,
  FILM,
  FINE_ART,
  FOOD_COOKING,
  HISTORY,
  WHAT_WATCH,
  MUSIC,
  TELEVISION,
  THEATER,
  RELATED_OPINION,
  RECENT_REVIEWS,
  REVIEWS_ROUNDUP,
  APPRECIATION,
  ARCHITECTURE_REVIEW,
  DANCE_REVIEW,
  OPERA_REVIEW,
  EXHIBITION_REVIEW,
  CULTURAL_COMMENTARY,
  VIDEO,
  MORE
};
